import {observer} from "mobx-react";
import {FieldAutoComplete, FieldInput} from "../../../ui";
import {CustomerItem, scanCustomerStore} from "../../../../store";
import {isValidVIN} from "../../../../utils";
import {useState} from "react";


interface ScanConfigurationData {
    customer: CustomerItem | undefined
    vin: string
}

const ScanConfigurationView = observer(function ScanConfigurationView({onChange, value}: {
    value: ScanConfigurationData
    onChange: (data: ScanConfigurationData) => any
}) {


    const [customerErrorMessage, setCustomerErrorMessage] = useState<string | undefined>()
    const [vinErrorMessage, setVinErrorMessage] = useState<string | undefined>()

    function validateVin(vin: string) {
        const vinInvalid = !Boolean(vin) || !isValidVIN(vin)
        setVinErrorMessage(vinInvalid ? '17 stellige Zahlen Buchstaben Kombination, I,O,Q ausgeschlossen': '')
    }

    return <>
        <div className={"columns"}>
            <div className={"column is-half"}>
                <FieldAutoComplete
                    label={"Kunde"}
                    required={true}
                    value={value.customer}
                    options={scanCustomerStore.items}
                    itemRenderer={c => c.label || c.id}
                    invalid={Boolean(customerErrorMessage)}
                    help={customerErrorMessage}
                    search={v => scanCustomerStore.search(v)}
                    onBlur={() => {
                        setCustomerErrorMessage(value.customer ? '' : 'Muss gesetzt sein')
                    }}
                    onChange={async (customer: CustomerItem | undefined) => {
                        setCustomerErrorMessage(customer ? '' : 'Muss gesetzt sein')
                        onChange({
                            ...value,
                            customer
                        })
                    }}
                />
            </div>
            <div className={"column is-half"}>
                <FieldInput
                    label={"FIN"}
                    required={true}
                    value={value.vin}
                    invalid={Boolean(vinErrorMessage)}
                    inputTransform={e => e.toUpperCase()}
                    maxLength={17}
                    onBlur={v => {
                        validateVin(value.vin)
                    }}
                    help={vinErrorMessage}
                    onChange={vin => {
                        validateVin(vin)
                        onChange({
                            ...value,
                            vin
                        })
                    }}
                />
            </div>
        </div>
    </>
})

export {
    ScanConfigurationView
}
